import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './Divider.scss';// to import local scss fle

const Divider = () => (
  <div className={cn('col s12', styles.dividerLine)} />
);

export default Divider;




// WEBPACK FOOTER //
// ./src/components/Divider/Divider.js